import { render, staticRenderFns } from "./AddMechanism.vue?vue&type=template&id=02f62a20&scoped=true"
import script from "./AddMechanism.vue?vue&type=script&lang=js"
export * from "./AddMechanism.vue?vue&type=script&lang=js"
import style0 from "./AddMechanism.vue?vue&type=style&index=0&id=02f62a20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f62a20",
  null
  
)

export default component.exports